import type { AppRouteRecordRaw } from '@/router/types'
import { useI18n } from '@/hooks/web/useI18n'
import { LAYOUT } from '@/router/constant'

const { t } = useI18n()
// 系统设置
const multimedia_routes: AppRouteRecordRaw[] = [
  // 多媒体管理
  {
    path: '/multimedia',
    name: 'multimedia',
    component: LAYOUT,
    meta: {
      title: t('router.multimediaManagement'),
      hideBreadcrumb: true,
      hideMenu: false,
      icon: 'laptop'
    },
    children: [
      // 节目发布
      {
        path: 'program-release',
        name: 'program-release',
        component: () => import('@/views/multimediaManage/program-release/index.vue'),
        meta: {
          title: t('router.programRelease'),
          hideBreadcrumb: true,
          hideMenu: false
        }
      },
      // 发布管理
      {
        path: 'release-manage',
        name: 'release-manage',
        component: () => import('@/views/multimediaManage/release-manage/index.vue'),
        meta: {
          title: t('router.releaseManage'),
          hideBreadcrumb: true,
          hideMenu: false
        }
      },
      // 发布管理-发布列表-编辑
      {
        path: 'publishList-editor',
        name: 'publishList-editor',
        component: () => import('@/views/multimediaManage/release-manage/publishEditor.vue'),
        meta: {
          title: t('router.releaseManage'),
          hideBreadcrumb: true,
          hideMenu: true
        }
      },
      // 发布管理-发布列表-查看
      {
        path: 'publishList-check',
        name: 'publishList-check',
        component: () => import('@/views/multimediaManage/release-manage/checkDetail.vue'),
        meta: {
          title: t('router.releaseManage'),
          hideBreadcrumb: true,
          hideMenu: true
        }
      },
      // 素材管理
      {
        path: 'material-management',
        name: 'material-management',
        component: () => import('@/views/multimediaManage/material-manage/index.vue'),
        meta: {
          title: t('router.materialManage'),
          hideBreadcrumb: true,
          hideMenu: false
        }
      },
      // 节目管理
      {
        path: 'program-manage',
        name: 'program-manage',
        component: () => import('@/views/multimediaManage/program-manage/index.vue'),
        meta: {
          title: t('router.programManage'),
          hideBreadcrumb: true,
          hideMenu: false
        }
      },
      // 新建节目
      {
        path: 'newBuilt-program',
        name: 'newBuilt-program',
        component: () => import('@/views/multimediaManage/program-manage/newBuiltProgram.vue'),
        meta: {
          title: t('router.programManage'),
          hideBreadcrumb: true,
          hideMenu: true
        }
      },
      // 系统设置
      {
        path: 'system-setting',
        name: 'system-setting',
        component: () => import('@/views/multimediaManage/system-setting/index.vue'),
        meta: {
          title: t('router.systemSetting'),
          hideBreadcrumb: true,
          hideMenu: false
        }
      }
    ]
  }
]

export default multimedia_routes
